import { StatusCodes } from "http-status-codes";
import { request } from "../../api";
import { headers } from "../../../../config/config";
import { MESSAGE } from "../../../../constants/api/message";
import { AUTHORIZATION } from "../../../../constants/api/auth";
const { post, get } = request;
const { Authorization, Bearer } = AUTHORIZATION;

const initialRoute = "creation";

// eslint-disable-next-line prettier/prettier, arrow-parens
export const createDependent = async (_formData) => {
	try {
		const endpoint = `${initialRoute}/create-dependent`;
		const token = localStorage.getItem("@jwt");
		const response = await post(endpoint, _formData, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.post.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			if (message === "Unauthorized Role!") {
				alert("Unauthorized Role!");
			} else if (message === "Invalid Email!") {
				alert("Invalid Email!");
			} else if (message === "Email is already registered!") {
				alert("Email is already registered!");
			} else if (message === "SSN is already registered!") {
				alert("SSN is already registered!");
			} else if (message === "Employee has not yet created!") {
				alert("Employee has not yet created!");
			} else if (message === "Dependent is already Created!") {
				alert("Dependent is already Created!");
			} else if (message === "Cannot add more than 7 dependents!") {
				alert("Cannot add more than 7 dependents!");
			} else if (message === MESSAGE.post.fail) {
				alert("Failed to Create Dependent!");
			} else alert("Other Errors of Status Code 400");
		} else {
			throw error;
		}
	}
};
